import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { primary, secondary } = theme.palette;

  return {
    searchDetails: {
      padding: "15px 27px 24px 24px",
      borderBottom: `1px solid ${primary.light}`
    },
    title: {
      paddingBottom: 13,
      color: primary.main
    },
    root: {
      "& .MuiAutocomplete-tagSizeSmall": {
        backgroundColor: "#222",
        color: theme.palette.common.white,
        "& .MuiChip-deleteIconSmall": {
          fill: "#fff"
        }
      },
      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
        transform: "translate(10px, -5px) scale(0.82)"
      }
    },
    inputRoot: {
      padding: 7,
      fontSize: 12
    },
    endAdornment: {
      "& .MuiButtonBase-root .MuiSvgIcon-root": {
        fill: primary.main
      }
    },
    listBox: {
      padding: 0
    },
    option: {
      borderBottom: "1px solid #eee",
      height: 42,
      color: primary.main
    },
    clearIndicator: {
      visibility: "visible"
    },
    popper: {
      zIndex: 1501
    },
    textField: {
      "& label": {
        fontSize: 12,
        "&.Mui-focused": {
          color: secondary.dark,
          fontSize: 12
        }
      },
      "& .MuiOutlinedInput-root": {
        minHeight: 38,
        "& fieldset": {
          border: `1px solid ${primary.light}`
        },
        "&.Mui-focused fieldset": {
          border: `1px solid ${secondary.dark}`
        }
      }
    }
  };
});
